import Phaser from 'phaser'
var replayButton 
export default class YouWinscene extends
Phaser.Scene 
{ 
    constructor () 
    {  
        super('you-win-scene')
    }

    init (data) 
    {
        this.gameHalfWidth = this.scale.width * 0.5 
        this.gameHalfHeight = this.scale.height * 0.5 

        this.score = data.score 
    }
    
    preload() 
    {
        this.load.image('background', 'images/sky.png')
        this.load.image('youwin', 'images/youwin.png')
        this.load.image('replay', 'images/replay.png')
        this.load.image ('cloud', 'images/cloud.png')
    }

    create() 
    { 
        this.add.image (this.gameHalfWidth, this.gameHalfHeight, 'background').setScale(2)
        this.clouds = this.physics.add.staticGroup ( { 
            key : 'cloud',
            repeat: 50
        })
        Phaser.Actions.RandomRectangle (this.clouds.getChildren(), this.physics.world.bounds);
        this.add.image (this.gameHalfWidth, this.gameHalfHeight, 'youwin').setScale(2)
        this.replayButton= this.add.image (this.gameHalfWidth, this.gameHalfHeight + 220, 'replay').setInteractive()
        this.replayButton.once('pointerup', () => {this.scene.start('reo-mathematics-scene', { score: null,
            totalEnemy: null})})
            // @ts-ignore
            this.add.text(this.gameHalfWidth - 160, this.gameHalfHeight-300, 'SCORE:', {fontSize: '60px', fill: '#000'})
            // @ts-ignore
            this.add.text(this.gameHalfWidth + 50, this.gameHalfHeight-300, this.score, { fontSize: '60px', fill: '#000'})
       
    }

}
